(function () {
  if (window.LJEventTrackingLoaded) return;
  window.LJEventTrackingLoaded = true;

  var EVENTBRITE_LINK_SELECTOR = '[data-seo-track="eventbrite-outbound"], a[href*="eventbrite.com/e/"]';

  function safeText(value) {
    return String(value || "").trim().replace(/\s+/g, " ").slice(0, 160);
  }

  function eventIdFromUrl(url) {
    var match = String(url || "").match(/tickets-(\d+)(?:[/?#]|$)/i);
    return match ? match[1] : "";
  }

  function placementFor(link) {
    if (link.dataset.eventPlacement) return link.dataset.eventPlacement;
    if (link.closest('.leaflet-popup')) return 'event-map-popup';
    if (link.closest('.lj-event-card')) return 'event-card';
    if (link.closest('.lj-event-page')) return 'event-detail';
    if (link.closest('.lj-event-map-actions')) return 'event-hub-header';
    return 'event-link';
  }

  function eventContext(link) {
    var container = link.closest('[data-event-id], .lj-event-card, .lj-event-page') || document;
    var heading = container.querySelector && container.querySelector('h1, h3');
    var eventId = (container.dataset && container.dataset.eventId) || link.dataset.eventId || eventIdFromUrl(link.href);
    return {
      event_id: safeText(eventId),
      event_name: safeText((container.dataset && container.dataset.eventName) || link.dataset.eventName || (heading && heading.textContent)),
      event_city: safeText((container.dataset && container.dataset.eventCity) || link.dataset.eventCity),
      event_venue: safeText((container.dataset && container.dataset.eventVenue) || link.dataset.eventVenue),
      event_date: safeText((container.dataset && container.dataset.eventDate) || link.dataset.eventDate),
      value: Number((container.dataset && container.dataset.eventPrice) || link.dataset.eventPrice || 0) || 0,
      currency: 'USD',
      placement: placementFor(link),
      link_text: safeText(link.textContent),
      link_url: link.href
    };
  }

  function decorateLink(link) {
    if (!link || !link.href) return;
    try {
      var url = new URL(link.href, window.location.href);
      if (!/(^|\.)eventbrite\.com$/i.test(url.hostname)) return;
      var context = eventContext(link);
      if (!url.searchParams.has('utm_source')) url.searchParams.set('utm_source', 'ljplants');
      if (!url.searchParams.has('utm_medium')) url.searchParams.set('utm_medium', 'website');
      if (!url.searchParams.has('utm_campaign')) url.searchParams.set('utm_campaign', 'bonsai_cheers');
      if (!url.searchParams.has('utm_content')) {
        url.searchParams.set('utm_content', [context.placement, context.event_id].filter(Boolean).join('_'));
      }
      link.href = url.toString();
    } catch (_) {}
  }

  function publish(context) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'eventbrite_outbound' }, context));

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('eventbrite_outbound', context);
      }
    } catch (_) {}

    try {
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'EventbriteOutbound', context);
      }
    } catch (_) {}
  }

  function decorateAll(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(EVENTBRITE_LINK_SELECTOR).forEach(decorateLink);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest(EVENTBRITE_LINK_SELECTOR);
    if (!link) return;
    decorateLink(link);
    publish(eventContext(link));
  }, true);

  function init() {
    decorateAll(document);
    if (!document.body || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(EVENTBRITE_LINK_SELECTOR)) decorateLink(node);
          decorateAll(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
